var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('a-spin', {
    attrs: {
      "spinning": _vm.loading
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "mb-4"
  }, [_c('strong', [_vm._v("General settings")])]), _c('a-row', [_c('a-col', {
    attrs: {
      "xs": {
        span: 24
      },
      "sm": {
        span: 12
      }
    }
  }, [_c('a-form-model', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('a-form-model-item', {
    ref: "name",
    attrs: {
      "prop": "name",
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "Name"
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "VAT code"
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.vatCode,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "vatCode", $$v);
      },
      expression: "form.vatCode"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "Bank name"
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.bankName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "bankName", $$v);
      },
      expression: "form.bankName"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "Bank account nr"
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.bankAccount,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "bankAccount", $$v);
      },
      expression: "form.bankAccount"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "Address line 1"
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.addressLine1,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "addressLine1", $$v);
      },
      expression: "form.addressLine1"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "Address line 2"
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.addressLine2,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "addressLine2", $$v);
      },
      expression: "form.addressLine2"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "ZIP code"
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.zipCode,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "zipCode", $$v);
      },
      expression: "form.zipCode"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "City"
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.city,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "city", $$v);
      },
      expression: "form.city"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "Country"
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.country,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "country", $$v);
      },
      expression: "form.country"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "Unit of measure"
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.unitOfMeasure,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "unitOfMeasure", $$v);
      },
      expression: "form.unitOfMeasure"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "Minimum bid"
    }
  }, [_c('a-input-number', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: _vm.form.minimumBid,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "minimumBid", $$v);
      },
      expression: "form.minimumBid"
    }
  })], 1), _c('h5', {
    staticClass: "mb-4"
  }, [_c('strong', [_vm._v("Email settings")])]), _c('a-form-model-item', {
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "Email"
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.email,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "email", $$v);
      },
      expression: "form.email"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "Server"
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.server,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "server", $$v);
      },
      expression: "form.server"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "Port"
    }
  }, [_c('a-input-number', {
    model: {
      value: _vm.form.port,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "port", $$v);
      },
      expression: "form.port"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "User"
    }
  }, [_c('a-input', {
    model: {
      value: _vm.form.emailUser,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "emailUser", $$v);
      },
      expression: "form.emailUser"
    }
  })], 1), _c('a-form-model-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "label": "Password"
    }
  }, [_c('a-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: _vm.form.emailPassword,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "emailPassword", $$v);
      },
      expression: "form.emailPassword"
    }
  })], 1), _c('a-button', {
    staticClass: "btn btn-success float-right",
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" Save ")])], 1)], 1)], 1)], 1)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }